<template>
  <span class="post-by-id-filter">
    <v-combobox
      v-model="postsById"
      :label="postsByIdLabel"
      chips
      multiple
      deletable-chips
      :placeholder="placeholder"
    />
  </span>
</template>

<script>

export default {
  name: 'PostByIdFilter',
  props: {
    value: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      placeholder: ' ',
    };
  },
  computed: {
    postsByIdLabel() {
      return this.$t('components.filters.PostByIdFilter.label');
    },
    postsById: {
      get() {
        if (this.value && this.value.value) {
          return this.value.value;
        }

        return [];
      },
      set(newValue) {
        if (!newValue || newValue.length === 0) {
          return this.$emit('input', undefined);
        }

        this.$emit('input', {
          value: newValue,
        });
      },
    },
  },
};

</script>

<style lang="scss">
  .post-by-id-filter {
    .v-select.v-select--chips .v-select__selections {
      min-height: 32px;
    }
  }
</style>
